import type { AchievementBackgroundProps } from '../Achievement';

export const SilverPlaceholder = ({ size }: AchievementBackgroundProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.3535 7.03906C33.4754 3.92827 38.5246 3.92827 41.6465 7.03906L44.791 10.1719C46.3871 11.7623 48.4734 12.7671 50.7119 13.0234L55.1221 13.5283C59.5007 14.0296 62.6489 17.978 62.1631 22.3584L61.6738 26.7695C61.4255 29.009 61.9413 31.2668 63.1367 33.1768L65.4912 36.9395C67.8294 40.6753 66.7062 45.5988 62.9785 47.9502L59.2246 50.3174C57.3188 51.5196 55.875 53.3305 55.127 55.4561L53.6533 59.6426C52.1904 63.7999 47.641 65.9911 43.4785 64.543L39.2861 63.085C37.1579 62.3444 34.8421 62.3444 32.7139 63.085L28.5215 64.543C24.359 65.9911 19.8096 63.7999 18.3467 59.6426L16.873 55.4561C16.125 53.3305 14.6812 51.5196 12.7754 50.3174L9.02148 47.9502C5.29385 45.5988 4.17058 40.6753 6.50879 36.9395L8.86328 33.1768C10.0587 31.2668 10.5745 29.009 10.3262 26.7695L9.83691 22.3584C9.35114 17.978 12.4993 14.0296 16.8779 13.5283L21.2881 13.0234C23.5266 12.7671 25.6129 11.7623 27.209 10.1719L30.3535 7.03906Z"
      fill="#EAEAEC"
      stroke="#9FA3A7"
      strokeWidth="2"
    />
  </svg>
);
